import { useCallback, useEffect } from "react";

export function EnumChecker(e: any){
    const values:any[] = Object.values(e); 
    return (a:any) => values.includes(a)
}

export function useShortcut(key:String, callback:()=>void){
    var fn = useCallback(callback, [callback]);
    useEffect(function(){

        function handleShortcuts(e:KeyboardEvent){
            var isDoc = e.target == document.body || e.target == document
            if(!isDoc) return;
            if(e.ctrlKey || e.shiftKey || e.metaKey) return;
            if(e.code == key){
                e.preventDefault();
                fn()
            }
        }

        window.addEventListener('keydown', handleShortcuts)
        return () => window.removeEventListener('keydown', handleShortcuts)
    }, [key, fn]);
}

export function inList(list:string|string[], item:string){
    if(!list) return false;
    const itemList = typeof list == 'string' ? list.split(/ *, */g) : list
    return itemList.includes(item);
}